import { Company } from '@models';
import { MutationPayload } from './mutation-payload';

export interface UpdateOrganizationResult {
  updateOrganization: UpdateOrganizationPayload;
}

export interface UpdateOrganizationPayload extends MutationPayload {
  organization?: Company;
}
